import { render, staticRenderFns } from "./RegisterOnlineIndex.vue?vue&type=template&id=31306540&"
import script from "./RegisterOnlineIndex.vue?vue&type=script&lang=js&"
export * from "./RegisterOnlineIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports